<template>
  <div v-if="cartLoadError" class="px-6 md:px-12 pt-40 pb-20 max-w-screen-2xl mx-auto font-poppins text-black">
    <h1 class="font-benzin text-2xl font-normal">WE COULDN'T LOAD <span class="text-brand-primary">THIS ORDER</span></h1>
    <p class="text-lg">{{ cartLoadError }}</p>
    <router-link to="/" class="underline">Search for an address instead</router-link>
  </div>
  <div class="" v-else-if="serviceQualification && !loadingCart">
    <div class="relative px-6 md:px-12 pt-14 mt-0 overflow-hidden pb-2 md:pb-28">
      <img src="https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/orderbg.png" alt="" class="absolute lg:inset-0 -inset-x-8 z-0 object-cover object-center w-auto lg:h-full h-96 lg:w-full" />
      <div class="relative z-20 pt-16 max-w-screen-2xl mx-auto">
        <h1 class="font-benzin text-white text-4xl font-light tracking-wide leading-tight pt-2 md:pt-20">CONNECT <br> TO <span class="text-brand-primary">NEXEE</span></h1>
        <p class="font-poppins max-w-md text-white">You're almost done! First, we'll need a few details from you to connect your new Nexee internet service.</p>
      </div>
      <div class="max-w-screen-2xl mx-auto relative z-20 md:bg-white md:bg-opacity-70 md:border md:border-solid border-black rounded-md px-4 md:px-12 py-8 mt-10 flex flex-col md:flex-row justify-between items-end">
        <div class="flex flex-col">
          <h2 class="text-black font-poppins-bold text-2xl py-0 my-0">This is your address:</h2>
          <p class="pt-6 font-poppins text-black text-lg my-0 ">{{  serviceQualification.address }}.</p>
          <p class="pt-0 font-poppins text-brand-primary font-bold text-sm italic my-0" v-show="serviceQualification.requiresNewDevelopmentCost && !ndcWaived">A one-time $300 network New Development Charge (NDC) applies to this address</p>
          <p class="pt-4 md:pt-8 font-poppins text-black text-sm my-0 underline" >If this is not your address, you can <strong>search for a new address.</strong></p>
          <div v-if="suggestedPromotion" class="font-poppins-bold pt-4">
            <h2 class="text-black font-poppins-bold text-2xl py-0 my-0">Promotions</h2>
            <h2 class="font-poppins text-lg py-0 my-0">Discounts available on the <strong class="text-gray-700 font-poppins">{{ suggestedPromotion.code }}</strong> promotion</h2>
            <p v-if="suggestedPromotion.conditions" class="text-gray-500 text-sm font-poppins">*{{ suggestedPromotion.conditions }}</p>
            <PromotionDiscounts class="mt-2 mb-16" :suggestedPromotion="suggestedPromotion"></PromotionDiscounts>
          </div>
        </div>
        <div class="w-full md:w-auto">
          <a href="#step1">
            <button class="mt-4 md:mt-0 transition duration-250 rounded-full hover:bg-white hover:border-solid hover:border-black bg-transparent bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark py-3 px-6 shadow-md text-center font-poppins text-black border-none text-lg w-full md:w-auto cursor-pointer">Get Started Now</button>
          </a>
        </div>
      </div>
    </div>
    <div class="" v-if="ready" id="step1">
      <div class="relative overflow-hidden bg-brand-primary pt-12 pb-8 px-0">
        <img src="https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/ribbon2-bg.png" alt=""
          style="top: 50%; left: 50%; transform: translate(-50%, -50%);" class="absolute inset-0 z-0 object-cover object-center w-full" />
        <div class="grid grid-cols-1 md:grid-cols-3 z-20 relative px-4 md:px-12 max-w-screen-2xl mx-automax-w-screen-2xl mx-auto">
          <div class="text-left col-start-1 flex flex-col col-span-2">
            <p class="text-md text-black font-poppins tracking-widest py-0 my-0">SELECT YOUR PLAN</p>
            <h3 class="font-benzin text-black text-2xl tracking-widest font-normal py-0 my-0">PICK A PLAN, <span class="text-white">POWER YOUR LIFE</span></h3>
            <p v-if="serviceQualification.carrier === 'OC'" class="text-lg text-black font-poppins tracking-normal py-0 my-0">Powered by Opticomm</p>
          </div>
          <div class="hidden md:block text-right col-span-1 col-start-3 ">
            <StepGuide :current-step="1"/>
          </div>
        </div>
        <div class="px-4 md:px-12 max-w-screen-2xl mx-auto">
          <PlanSelector2 class="mb-4 md:mb-20" @onPlanSelected="planSelected" :selected="selectedPlan" :products="plans" :canSelectProduct="true"></PlanSelector2>
        </div>
      </div>

      <div>
        <div class="grid grid-cols-1 md:grid-cols-3 z-50 relative px-4 md:px-12 pt-16 max-w-screen-2xl mx-auto">
          <div class="text-left col-start-1 flex flex-col">
            <p class="font-benzin text-black text-2xl tracking-normal font-normal py-0 my-0">SELECT YOUR <span class="text-brand-primary">CONTRACT</span></p>
            <p class="text-lg text-black font-poppins tracking-normal pt-2 py-0 my-0">What is your preferred contract term?</p>
          </div>
          <div class="hidden md:block text-right col-span-1 col-start-3 ">
            <StepGuide :current-step="2"/>
          </div>
        </div>
        <div class="px-4 md:px-12 max-w-screen-2xl mx-auto">
          <ContractLengthSelector class="mb-4 md:mb-20" @onContractSelected="contractSelected" :selected="selectedContract" :contractOptions="contracts"></ContractLengthSelector>
        </div>
      </div>

      <div>
        <div class="grid grid-cols-1 md:grid-cols-3 z-50 relative px-4 md:px-12 pt-6 md:pt-16 max-w-screen-2xl mx-auto">
          <div class="text-left col-start-1 flex flex-col col-span-2">
            <p class="font-benzin text-black text-2xl tracking-normal font-normal py-0 my-0">WOULD YOU LIKE A<span class="text-brand-primary"> VOIP SERVICE?</span></p>
            <p class="text-md text-black font-poppins tracking-normal pt-2 py-0 my-0">You can add our monthly talk service to your broadband internet plan.</p>
          </div>
          <div class="hidden md:block text-right col-span-1 col-start-3 ">
            <StepGuide :current-step="3"/>
          </div>
        </div>
        <div class="px-4 md:px-12 pt-6 max-w-screen-2xl mx-auto">
          <VoipSelector v-if="voice.length" class="mb-4 md:mb-20" @onVoipToggled="voipToggled" @onListingStatusToggled="listingStatusToggled" @onPlanSelected="voipPlanSelected" :isVoipListed="isVoipListed" :isVoipAdded="isVoipAdded" :selected="selectedVoipPlan" :products="voice"></VoipSelector>
        </div>
      </div>
      <div class="px-4 md:px-12 max-w-screen-2xl mx-auto">
        <hr>
      </div>

      <div>
        <div class="grid grid-cols-1 md:grid-cols-3 z-30 relative px-4 md:px-12 pt-6 max-w-screen-2xl mx-auto">
          <div class="text-left col-start-1 flex flex-col">
            <p class="font-benzin text-black text-2xl tracking-normal font-normal py-0 my-0">DO YOU NEED A<span class="text-brand-primary"> ROUTER?</span></p>
            <p class="text-lg text-black font-poppins tracking-normal pt-2 py-0 my-0">You can choose to purchase a router or supply your own. Prices listed include delivery.</p>
          </div>
          <div class="hidden md:block text-right col-span-1 col-start-3 ">
            <StepGuide :current-step="4"/>
          </div>
        </div>
        <div class="px-4 md:px-12 pt-6 max-w-screen-2xl mx-auto">
          <HardwareSelector v-if="availableHardware.length" class="mb-4 md:mb-20" @onHardwareToggled="hardwareToggled" @onHardwareSelected="hardwareSelected" :isHardwareAdded="isHardwareAdded" :selected="selectedHardware" :products="availableHardware"></HardwareSelector>
        </div>
      </div>

      <div class="px-4 md:px-12 max-w-screen-2xl mx-auto">
        <hr>
      </div>
      <div class="px-4 md:px-12 max-w-screen-2xl mx-auto pt-6">
        <div class="lg:grid lg:grid-cols-1 lg:gap-x-12 xl:gap-x-16">
          <div class="lg:col-start-1">
            <h2 class="text-2xl font-poppins-bold text-black">Order Summary</h2>
            <OrderSummary class="mt-4" :products="selectedProducts" :isPromoValid="isPromoValid" :promotionDiscounts="promotionDiscounts" :validPromotion="validPromotion" :suggestedPromotion="suggestedPromotion" :promoCode="promoCode" @onEnterPromoCode="promoCodeApplied"></OrderSummary>
          </div>
        </div>
      </div>
      <div class="px-4 md:px-12 max-w-screen-2xl mx-auto flex justify-end pt-6 mb-4 md:mb-20">
        <button @click="continueToConfirmOrder" class="transition duration-250 rounded-full hover:bg-white hover:border-solid hover:border-black bg-transparent bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark py-3 px-6 shadow-md text-center font-poppins text-black border-none text-lg w-full md:w-auto cursor-pointer">Continue To Order</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PlanSelector from '../components/ordering/PlanSelector.vue';
import PlanSelector2 from '../components/ordering/PlanSelector2.vue';
import StepGuide from '../components/ordering/StepGuide.vue';
import ContractLengthSelector from '../components/ordering/ContractLengthSelector.vue';
import OrderSummary from '../components/ordering/OrderSummary.vue';
import VoipSelector from '../components/ordering/VoipSelector.vue';
import HardwareSelector from '../components/ordering/HardwareSelector.vue';
import HeroText from '../components/content/HeroText.vue';
import Title from '../components/content/Title.vue';
import { Brand } from '../services/integration/enums';
import Container from '../components/content/Container.vue';
import { computed, onMounted, Ref, ref, reactive, watch } from 'vue';
import store, { OrderSelection } from '@/store';
import { ShoppingCartClientInterface } from '@/services/integration/clients/shoppingCartClientInterface';
import { ServiceQualificationAdapterInterface } from '@/adapters/serviceQualificationAdapterInterface';
import { LoadedCart, matchCartProducts, parseCart } from '@/utils/cartLoader';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { findPlanAction } from '@/utils/promotionActions';
import { Catalog, CatalogAdapterInterface, Product } from '@/adapters/catalogAdapterInterface';
import router from '@/router';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { PromotionsHandlerInterface } from '@/services/promotionsHandlerInterface';
import { Action, Promotion } from '@uniti/promotions-js-client/dist/utilities/types';
import PromotionDiscounts from '@/components/ordering/PromotionDiscounts.vue';

// Injections.
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');
const catalogAdapter = injectStrict<CatalogAdapterInterface>('CatalogAdapterInterface');
const promotionsHandler = injectStrict<PromotionsHandlerInterface>('PromotionsHandlerInterface');
const shoppingCartService = injectStrict<ShoppingCartClientInterface>('ShoppingCartClientInterface');
const serviceQualificationAdapter = injectStrict<ServiceQualificationAdapterInterface>('ServiceQualificationAdapterInterface');

// Data.
const catalogs: Ref<Array<Catalog>> = ref([]);
const plans: Ref<Array<Product>> = ref([]);
const hardware: Ref<Array<Product>> = ref([]);
const voice: Ref<Array<Product>> = ref([]);
const fees: Ref<Array<Product>> = ref([]);
const serviceDetails = reactive({
  rtcDays: 0,
  relocation: 0,
  newService: 0
});

// Promotions
const suggestedPromotion: Ref<Promotion|undefined> = ref();
const validPromotion: Ref<Promotion|undefined> = ref();
const promotionDiscounts: Ref<Array<Action>> = ref([]);
const promoCode: Ref<string|undefined> = ref();

const selectedProducts: Ref<Array<Product>> = ref([]);
const selectedPlan = ref('');
const selectedContract = ref('');
const selectedVoipPlan = ref('');
const selectedHardware = ref('');
const isVoipAdded = ref(false);
const isVoipListed = ref(false);
const isHardwareAdded = ref(false);
const isPromoValid: Ref<boolean> = ref(false);
const isPlanValid: Ref<boolean> = ref(false);
const isContractValid: Ref<boolean> = ref(false);

const ready = ref(false);
const loadingCart = ref(false);
const cartLoadError = ref('');

// Computed properties.
const serviceQualification = computed(() => {
  // Get SQ from store.
  return store.state.serviceQualification;
});
const contracts = computed(() => {
  // Contracts are all fees except the new development cost.
  return fees.value.filter(fee => fee.code !== 'NDC');
});

// Nokia WiFi Beacon 1.1 and Beacon 2 (and their bundles) are only offered
// when the promotion includes a FREE-ROUTER discount.
const isFreeRouterOnlyHardware = (product: Product): boolean => {
  return /^Nokia WiFi Beacon (1\.1|2)( Bundle \d+)?$/.test(product.name);
};

const hasFreeRouterPromotion = computed(() => {
  return [suggestedPromotion.value, validPromotion.value].some(promotion => {
    return promotion?.actions.some(action => action.actionCatalogObject.code === 'FREE-ROUTER');
  });
});

const availableHardware = computed(() => {
  if (hasFreeRouterPromotion.value) {
    return hardware.value;
  }
  return hardware.value.filter(product => !isFreeRouterOnlyHardware(product));
});

// Watchers
// Counts promo code changes so only the latest one updates the router selection.
let promotionRun = 0;
watch(promoCode, async (promoCode) => {
  const run = ++promotionRun;
  suggestedPromotion.value = undefined;

  if (serviceQualification.value && promoCode) {
    suggestedPromotion.value = await await promotionsHandler.suggest(serviceQualification.value, brandService.getName(), catalogs.value, promoCode);
  }

  if (promoCode && serviceQualification.value && suggestedPromotion.value === undefined) {
    validPromotion.value = await promotionsHandler.validate(serviceQualification.value, selectedProducts.value, brandService.getName(), promoCode, catalogs.value, serviceDetails);
  }

  // Remove all the existing discounts so we can re-calculate them for a new promotion.
  plans.value = promotionsHandler.removeDiscountsFromProducts(plans.value);
  fees.value = promotionsHandler.removeDiscountsFromProducts(fees.value);
  hardware.value = promotionsHandler.removeDiscountsFromProducts(hardware.value);
  promotionDiscounts.value = promotionDiscounts.value = [];

  // If suggestedPromotion exists modify products based on the promotion actions
  if (suggestedPromotion.value) {
    validPromotion.value = suggestedPromotion.value;

    plans.value = promotionsHandler.mapActionsToProducts(validPromotion.value, plans.value);
    fees.value = promotionsHandler.mapActionsToProducts(validPromotion.value, fees.value);
    hardware.value = promotionsHandler.mapActionsToProducts(validPromotion.value, hardware.value);
  }

  // Run the selected products handler to verify the promotion
  selectedProductsHandler(selectedProducts.value);
  // Set the discounts to display depending on the the promo / plan / contract
  ifPromoValid(isPromoValid.value);
  ifPlanValid(isPlanValid.value);
  ifContractValid(isContractValid.value);

  if (run === promotionRun) {
    removeUnavailableHardware();
  }
});

watch(selectedProducts, async (selectedProducts) => {
  selectedProductsHandler(selectedProducts);
});

watch(isPromoValid, isPromoValid => {
  ifPromoValid(isPromoValid);
});

watch(isPlanValid, isPlanValid => {
  ifPlanValid(isPlanValid);
});

watch(isContractValid, isContractValid => {
  ifContractValid(isContractValid);
});

// Hooks.
onMounted(async () => {
  // Opened with ?cartId= to edit a previous order. Skip the fetch when coming back
  // from the confirm order page with this cart, so any changes made are kept.
  const cartIdParam = router.currentRoute.value.query.cartId;
  let cartToApply: LoadedCart | null = null;
  const alreadyEditingCart = (store.state.loadedCart?.id === cartIdParam || store.state.cartId === cartIdParam) && store.state.orderSelection;
  if (typeof cartIdParam === 'string' && cartIdParam && !alreadyEditingCart) {
    cartToApply = await loadCart(cartIdParam);
    if (!cartToApply) {
      return;
    }
  }

  // Get catalogs for brand
  catalogs.value = await catalogAdapter.getCatalog(brandService.getName());

  if (serviceQualification.value) {
    // Return a suggested promotion from the promotions-client
    suggestedPromotion.value = await promotionsHandler.suggest(serviceQualification.value, brandService.getName(), catalogs.value, promoCode.value);

    if (suggestedPromotion.value) {
      promoCode.value = suggestedPromotion.value.code;
    }

    // Get plans for the SQ.
    plans.value = await catalogAdapter.getPlans(serviceQualification.value);
    hardware.value = await catalogAdapter.getHardware(serviceQualification.value);
    voice.value = await catalogAdapter.getVoice(serviceQualification.value);
    fees.value = await catalogAdapter.getFees(serviceQualification.value);

    // If suggestedPromotion exists modify products based on the promotion actions
    if (suggestedPromotion.value) {
      plans.value = promotionsHandler.mapActionsToProducts(suggestedPromotion.value, plans.value);
      fees.value = promotionsHandler.mapActionsToProducts(suggestedPromotion.value, fees.value);
      hardware.value = promotionsHandler.mapActionsToProducts(suggestedPromotion.value, hardware.value);
    }

    // If there's no plans we go to the
    // "Hey sorry we can't do anything" page.
    if (!plans.value.length || !fees.value.length) {
      router.push('/not-serviceable');
      return;
    }

    // Select everything from the loaded cart.
    if (cartToApply) {
      restoreSelection({
        selectedProducts: matchCartProducts(cartToApply, { plans: plans.value, hardware: hardware.value, voice: voice.value, fees: fees.value }),
        promoCode: cartToApply.promoCode,
        isVoipListed: false
      });
      ready.value = true;
      return;
    }

    // Restore what was picked before if coming back from the confirm order page.
    const previousSelection = store.state.orderSelection;
    if (previousSelection) {
      restoreSelection(previousSelection);
      ready.value = true;
      return;
    }

    // Set default plan and contract.
    const plansCopy = [...plans.value];
    const sortedPlans = plansCopy.sort((a, b) => {
      return (a.price > b.price) ? -1 : 1;
    });
    const defaultPlan = sortedPlans[0];
    planSelected(defaultPlan.id);
    const defaultContract = fees.value.find(fee => fee.name === '12 Months') || fees.value[0];
    contractSelected(defaultContract.id);

    // Set the new development cost if this address requires it.
    if (serviceQualification.value.requiresNewDevelopmentCost) {
      const ndcFee = fees.value.find(fee => fee.code === 'NDC');
      if (ndcFee) {
        selectedProducts.value.push(ndcFee);
      }
    }
  } else {
    // If SQ hasn't been done, we can't use this page.
    router.push('/');
  }

  // Display user interface now.
  ready.value = true;
});

const loadCart = async (cartId: string): Promise<LoadedCart | null> => {
  loadingCart.value = true;
  try {
    const loadedCart = parseCart(cartId, await shoppingCartService.getCart(cartId));
    if (!loadedCart.carrier || !loadedCart.locationId) {
      throw new Error(`Cart ${cartId} has no carrier or location ID.`);
    }

    const service = await serviceQualificationAdapter.serviceQualificationByCarrier(loadedCart.carrier, loadedCart.locationId);
    if (!service) {
      throw new Error(`No service qualification for cart ${cartId}.`);
    }

    // Setting the SQ clears any previous selection/cart, so set the cart after.
    store.commit('setServiceQualification', service);
    store.commit('setLoadedCart', loadedCart);
    store.commit('setCartId', loadedCart.id);
    return loadedCart;
  } catch (error) {
    console.error(error);
    cartLoadError.value = 'Please check the link and try again, or start a new order.';
    return null;
  } finally {
    loadingCart.value = false;
  }
};

const promoCodeApplied = (promoCodeInput?: string) => {
  promoCode.value = promoCodeInput;
};

const selectedProductsHandler = async (selectedProducts: Product[]) => {
  if (serviceQualification.value && promoCode.value) {
    validPromotion.value = await promotionsHandler.validate(serviceQualification.value, selectedProducts, brandService.getName(), promoCode.value, catalogs.value, serviceDetails);
  } else {
    validPromotion.value = undefined;
  }
  // Set the validity of the promotion
  isPromoValid.value = Boolean(validPromotion.value);

  // Set if the selected contract / plan is valid - this is done so we can still display discounts on a partially validated promotion
  if (promoCode.value) {
    isContractValid.value = await promotionsHandler.isContractLengthValid(selectedProducts, promoCode.value, brandService.getName());
    isPlanValid.value = await promotionsHandler.isPlanValid(selectedProducts, promoCode.value, brandService.getName());
  } else {
    isContractValid.value = false;
    isPlanValid.value = false;
  }

  // If the promotion is valid we check to see if there is a delayedNdc or Free Year action on the promotion. This is used to render
  // promotional descriptions in the order summary.
  if (isPromoValid.value) {
    promotionDiscounts.value = [];

    const ndcProduct = selectedProducts.find(product => product.code === 'NDC');
    const internetProduct = selectedProducts.find(product => product.type === 'internet');

    if (ndcProduct) {
      const delayedNdcAction = validPromotion.value?.actions.find(action => action.actionCatalogObject.code === 'DELAYED-NDC');
      if (delayedNdcAction) promotionDiscounts.value.push(delayedNdcAction);
    }

    if (internetProduct) {
      // Plan-based actions only show when they apply to the selected plan.
      const yearOffAction = findPlanAction(validPromotion.value, 'YEAR-OFF', selectedProducts);
      if (yearOffAction) promotionDiscounts.value.push(yearOffAction);

      const oneOffAction = findPlanAction(validPromotion.value, 'ONE-OFF', selectedProducts);
      if (oneOffAction) promotionDiscounts.value.push(oneOffAction);
    }

    const freePreInstalledRouterAction = validPromotion.value?.actions.find(action => action.actionCatalogObject.code === 'FREE-ROUTER-INSTALLED');
    if (freePreInstalledRouterAction) promotionDiscounts.value.push(freePreInstalledRouterAction);
  } else {
    promotionDiscounts.value = [];
  }

  if (isPromoValid.value && validPromotion.value) {
    // Remove the display discount conditions so we can re-add if applicable
    // hardware.value = promotionsHandler.removeDiscountsFromProducts(hardware.value);
    // Apply the discounts using applicable when Id's
    promotionsHandler.applyApplicableWhenConditionToProducts(validPromotion.value, selectedProducts, hardware.value);
  }
};

const ifPromoValid = (isPromoValid: boolean) => {
  // If a suggested promotion is valid we display the discounts that have been applied to the products
  if (isPromoValid) {
    hardware.value = promotionsHandler.addDisplayDiscountConditionToProducts(hardware.value);
  } else {
    hardware.value = promotionsHandler.removeDisplayDiscountConditionFromProducts(hardware.value);
  }
};

const ifPlanValid = (isPlanValid: boolean) => {
  // If a suggested promotion exists and the contract is valid we display the discounted plan fees
  if (isPlanValid) {
    fees.value = promotionsHandler.addDisplayDiscountConditionToProducts(fees.value);
  } else {
    fees.value = promotionsHandler.removeDisplayDiscountConditionFromProducts(fees.value);
  }
};

const ifContractValid = (isContractValid: boolean) => {
  // If a suggested promotion exists and the contract is valid we display the discounted plan fees
  if (isContractValid) {
    plans.value = promotionsHandler.addDisplayDiscountConditionToProducts(plans.value);
  } else {
    plans.value = promotionsHandler.removeDisplayDiscountConditionFromProducts(plans.value);
  }
};

const planSelected = (id: string) => {
  selectedPlan.value = id;

  // Remove plans.
  selectedProducts.value = selectedProducts.value.filter(product => product.type !== 'internet');

  // Add new plan.
  const plan = plans.value.find(plan => plan.id === id);
  if (plan) {
    selectedProducts.value.push(plan);
  }
};

const contractSelected = (id: string) => {
  selectedContract.value = id;

  // Remove contracts.
  selectedProducts.value = selectedProducts.value.filter(product => product.type !== 'fee' || product.code === 'NDC');

  // Add new contract.
  const contract = fees.value.find(plan => plan.id === id);
  if (contract) {
    selectedProducts.value.push(contract);
  }
};

const voipPlanSelected = (id: string) => {
  selectedVoipPlan.value = id;

  // Remove voip.
  selectedProducts.value = selectedProducts.value.filter(product => product.type !== 'voice');

  // Add new voip.
  const plan = voice.value.find(plan => plan.id === id);
  if (plan) {
    selectedProducts.value.push(plan);
  }
};

const hardwareSelected = (id: string) => {
  selectedHardware.value = id;

  // Remove hardware.
  selectedProducts.value = selectedProducts.value.filter(product => product.type !== 'hardware');

  // Add new hardware.
  const modem = hardware.value.find(plan => plan.id === id);
  if (modem) {
    selectedProducts.value.push(modem);
  }
};

const voipToggled = (event: boolean) => {
  isVoipAdded.value = event;
  if (!isVoipAdded.value) {
    // Remove hardware plans.
    selectedProducts.value = selectedProducts.value.filter(product => product.type !== 'voice');
  } else {
    // Add a default.
    voipPlanSelected(voice.value[0].id);
  }
};

const hardwareToggled = (event: boolean) => {
  isHardwareAdded.value = event;
  if (!isHardwareAdded.value) {
    // Remove voice plans.
    selectedProducts.value = selectedProducts.value.filter(product => product.type !== 'hardware');
  } else {
    // Add a default.
    hardwareSelected(availableHardware.value[0].id);
  }
};

// If the selected router is no longer offered (e.g. the free router promo was
// removed), switch to the first router that is.
const removeUnavailableHardware = () => {
  if (!isHardwareAdded.value || availableHardware.value.some(product => product.id === selectedHardware.value)) {
    return;
  }

  if (availableHardware.value.length) {
    hardwareSelected(availableHardware.value[0].id);
  } else {
    hardwareToggled(false);
  }
};

const listingStatusToggled = (event: boolean) => {
  isVoipListed.value = event;
};

const ndcWaived = computed(() => {
  if (suggestedPromotion.value && suggestedPromotion.value.actions.length > 0) {
    return suggestedPromotion.value?.actions.find(action => action.actionCatalogObject.code === 'FREE-NDC');
  }
  return false;
});

const restoreSelection = (previousSelection: OrderSelection) => {
  const previous = previousSelection.selectedProducts;
  const previousPlan = plans.value.find(plan => previous.some(product => product.id === plan.id));
  const defaultPlan = [...plans.value].sort((a, b) => (a.price > b.price) ? -1 : 1)[0];
  planSelected((previousPlan || defaultPlan).id);

  const previousContract = contracts.value.find(contract => previous.some(product => product.id === contract.id));
  const defaultContract = fees.value.find(fee => fee.name === '12 Months') || fees.value[0];
  contractSelected((previousContract || defaultContract).id);

  const previousVoip = voice.value.find(plan => previous.some(product => product.id === plan.id));
  if (previousVoip) {
    isVoipAdded.value = true;
    voipPlanSelected(previousVoip.id);
  }
  isVoipListed.value = previousSelection.isVoipListed;

  // A new promo code re-checks the router once it resolves (see the promoCode watcher).
  const promoCodeChanging = Boolean(previousSelection.promoCode) && previousSelection.promoCode !== promoCode.value;
  if (previousSelection.promoCode) {
    promoCode.value = previousSelection.promoCode;
  }

  // Checked against all routers: any free-router promo is applied once promoCode resolves,
  // which then removes the router if it isn't offered.
  const previousHardware = hardware.value.find(modem => previous.some(product => product.id === modem.id));
  if (previousHardware) {
    isHardwareAdded.value = true;
    hardwareSelected(previousHardware.id);
  }
  if (!promoCodeChanging) {
    removeUnavailableHardware();
  }

  if (serviceQualification.value?.requiresNewDevelopmentCost) {
    const ndcFee = fees.value.find(fee => fee.code === 'NDC');
    if (ndcFee) {
      selectedProducts.value.push(ndcFee);
    }
  }
};

const continueToConfirmOrder = () => {
  const orderSelection: OrderSelection = {
    selectedProducts: [...selectedProducts.value],
    promoCode: promoCode.value,
    isVoipListed: isVoipListed.value
  };
  store.commit('setOrderSelection', orderSelection);
  const orderCartId = store.state.loadedCart?.id || store.state.cartId;
  router.push({ path: '/confirm-order', query: orderCartId ? { id: orderCartId } : {} });
};
</script>
